import { render, staticRenderFns } from "./voice-input-button.vue?vue&type=template&id=5c63ee44&scoped=true&"
import script from "./voice-input-button.vue?vue&type=script&lang=js&"
export * from "./voice-input-button.vue?vue&type=script&lang=js&"
import style0 from "./voice-input-button.vue?vue&type=style&index=0&id=5c63ee44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c63ee44",
  null
  
)

export default component.exports